import React from 'react';

/**
 * Tailwind tabs — replaces MUI Tabs/Tab.
 * tabs: [{ value, label, icon? }], value, onChange(value)
 *
 * variant:
 *  - "underline" (default) — bottom border active state
 *  - "pill" — rounded filled pills like Palla dashboard (Overview / Analytics / …)
 */
const Tabs = ({ tabs = [], value, onChange, className = '', variant = 'underline' }) => {
  if (variant === 'pill') {
    return (
      <div
        className={`flex h-12 flex-wrap items-center justify-start gap-2 p-0 ${className}`}
        role="tablist"
      >
        {tabs.map((tab) => {
          const active = tab.value === value;
          return (
            <button
              key={String(tab.value)}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onChange && onChange(tab.value)}
              className={`inline-flex h-10 items-center gap-1.5 whitespace-nowrap rounded-lg px-6 text-sm font-medium transition-all ${
                active
                  ? 'bg-[#0061B2] text-white shadow-md'
                  : 'bg-transparent text-[#637381] hover:bg-[#0061B2]/10 hover:text-[#212B36]'
              }`}
            >
              {tab.icon}
              {tab.label}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className={`flex gap-1 overflow-x-auto border-b border-[#E9EDF6] ${className}`} role="tablist">
      {tabs.map((tab) => {
        const active = tab.value === value;
        return (
          <button
            key={String(tab.value)}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange && onChange(tab.value)}
            className={`inline-flex items-center gap-1.5 whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-semibold transition-colors ${
              active
                ? 'border-[#0061B2] text-[#0061B2]'
                : 'border-transparent text-[#637381] hover:text-[#212B36]'
            }`}
          >
            {tab.icon}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
